import moment from 'moment';

import api from '../../../api';

export const getOpportunity = async () => {
	const url = '/oportunidade';
	const response = await api.get(url);
	return response.data;
};

export const getOpportunityById = async ({ queryKey }) => {
	const [, id] = queryKey;
	const url = `/oportunidade/oportunidadeById?oportunidade_id=${id}`;
	const response = await api.get(url);
	return response.data;
};

export const createOpportunity = async body => {
	const url = '/oportunidade';
	const response = await api.post(url, body);
	return response.data;
};

export const editOpportunity = async (body, id: number) => {
	const url = `/oportunidade?empresa_id=1&oportunidade_id=${id}`;
	const response = await api.patch(url, body);
	return response.data;
};

export const deleteOpportunity = async (id: number) => {
	const url = `/oportunidade?empresa_id=1&oportunidade_id=${id}`;
	const response = await api.delete(url);
	return response.data;
};

export const getOpportunityConsensusException = async body => {
	const { cycleId, date } = body.preFilteredRows;

	const dateMoment = moment(date, 'YYYY-MM');
	const startOfMonth = dateMoment.startOf('month').format('YYYY-MM-DD');
	const endOfMonth = dateMoment.endOf('month').format('YYYY-MM-DD');

	const defaultFilters = [
		{
			column_name: 'data',
			operation: 'greater_equal',
			value_type: 'date',
			values: startOfMonth,
		},
		{
			column_name: 'data',
			operation: 'less_equal',
			value_type: 'date',
			values: endOfMonth,
		},
		{
			column_name: 'in_ciclo',
			operation: 'equal',
			value_type: 'boolean',
			values: true,
		},
	];

	const userFilters = body.filters || [];

	const mergedFilters = [...defaultFilters, ...userFilters];

	const payload = {
		pagination: body.pagination || {
			page: 0,
			size: 100,
			order: [],
		},
		ciclo_id: Number(cycleId),
		filters: mergedFilters,
	};

	const response = await api.post('/oportunidade/view', payload);

	const responseData = response.data;

	const validColumnNames = new Set([
		'codigo',
		'sequencia_codigo',
		'data',
		'mes_ano_ciclo',
		'nome_cliente',
		'documento',
		'nome_familia',
		'nome_produto',
		'codigo_produto',
		'quantidade',
		'receita_bruta',
		'nome_canal_venda',
		'nome_membro',
		'consenso_excecao',
		'data_registro',
	]);

	const filteredFilterMap =
		responseData.filterMap?.filter(filter =>
			validColumnNames.has(filter.column_name)
		) || [];

	return {
		data: responseData.data || [],
		count: responseData.count || 0,
		filterMap: filteredFilterMap,
		dependencias: responseData.dependencias || [],
	};
};

export const deleteOpportunityByFilters = async (filters: any) => {
	const response = await api.post('oportunidade/deletarPorFiltros', filters);
	return response.data;
};
